import React from 'react';

import {Body, Cell, Row, Table} from '@pb/kit-component-table';

import {infoMessage} from '../vendor-management.module.styl';

import {VendorManagementTableHeader} from './vendor-management-table-header';

type Props = {
    hasActiveFilter: boolean,
    totalCount: number,
    allSelected: boolean,
    onSelectAll: () => void,
    onClearAll: () => void,
};

export const NoResults: React.FC<Props> = ({
    hasActiveFilter,
    totalCount,
    allSelected,
    onSelectAll,
    onClearAll,
}) => (
    <Table borderedColumns={true}>
        <VendorManagementTableHeader
            totalCount={totalCount}
            allSelected={allSelected}
            onSelectAll={onSelectAll}
            onClearAll={onClearAll}
        />
        <Body>
            <Row>
                <Cell colSpan={6}>
                    <div style={{padding: '32px', textAlign: 'center'}}>
                        <div style={{fontWeight: 600, marginBottom: 4}}>No vendors found</div>
                        {hasActiveFilter ? (
                            <div className={infoMessage}>
                                Try adjusting the search criteria
                            </div>
                        ) : null}
                    </div>
                </Cell>
            </Row>
        </Body>
    </Table>
);
